import React from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default function APIDocsRoadmapObjectBlock() {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">The roadmap object</div>
        <APIDocsTable
          title="Attributes"
          rows={[
            {
              description: 'A unique identifier for the roadmap.',
              heading: 'id',
              subheading: 'string',
            },
            {
              description: 'Whether the roadmap has been archived.',
              heading: 'archived',
              subheading: 'boolean',
            },
            {
              description: 'Time at which the roadmap was created, in ISO 8601 format.',
              heading: 'created',
              subheading: 'string',
            },
            {
              description: 'The name of the roadmap.',
              heading: 'name',
              subheading: 'string',
            },
            {
              description: 'The number of posts associated with the roadmap.',
              heading: 'postCount',
              subheading: 'number',
            },
            {
              description: 'The URL to the roadmap in the admin view.',
              heading: 'url',
              subheading: 'string',
            },
          ]}
        />
      </div>
      <div>
        <div className="text">Example roadmap object:</div>
        <Highlight lang="json">
          {`{
  "id": "553c3ef8b8cdcd1501ba12bb",
  "archived": false,
  "created": "2024-09-30T13:32:01.000Z",
  "name": "Example Roadmap",
  "postCount": 12,
  "url": "https://your-company.canny.io/admin/roadmap/example-roadmap"
}`}
        </Highlight>
      </div>
    </APIDocsBlock>
  );
}
